import { render } from "./ResponseForm.vue?vue&type=template&id=af7005b6&scoped=true&ts=true&lang=pug"
import script from "./ResponseForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponseForm.vue?vue&type=script&setup=true&lang=ts"

import "./ResponseForm.vue?vue&type=style&index=0&id=af7005b6&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7005b6"]])

export default __exports__